import { APPOINTMENT_SECTOR } from 'constants/Actions/AppointmentSector';

// Estado inicial del reducer
const aInitialState = {
    aAppointmentSectors: [],
    aAllAppointmentSectors: [],
    oAppointmentSector: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a los sectores de citas almacenados en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Matías Rivero
 */
export const AppointmentSectorReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case APPOINTMENT_SECTOR.GET:
            return { ...aState, aAppointmentSectors: oAction.data };
        case APPOINTMENT_SECTOR.GET_ALL:
            return { ...aState, aAllAppointmentSectors: oAction.data };
        case APPOINTMENT_SECTOR.FIND:
            return { ...aState, oAppointmentSector: oAction.data };
        case APPOINTMENT_SECTOR.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case APPOINTMENT_SECTOR.ERROR:
            return { ...aState, bIsError: true };
        case APPOINTMENT_SECTOR.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oAppointmentSector: null, aAppointmentSectors: [], aAllAppointmentSectors: [] };
        default:
            return aState;
    }
}
